// extracted by mini-css-extract-plugin
export default {"grid":"Properties_grid__7vAxF"};